import { Input, TextareaAutosize, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export const PixverseTransitionSettings = ({
  onSettingsChange,
  selectedPrompt,
  generateExact,
}) => {
  const [prompt, setPrompt] = useState(selectedPrompt?.prompt || "");
  const [seed, setSeed] = useState(generateExact ? selectedPrompt?.seed : "");
  const handleSettingChange = (key, value) => {
    if (onSettingsChange) {
      onSettingsChange({ [key]: value });
    }
  };

  useEffect(() => {
    // Update settings when selectedPrompt changes
    if (selectedPrompt?.prompt) {
      setPrompt(selectedPrompt?.prompt);
      handleSettingChange("prompt", selectedPrompt?.prompt);
    }else{
      setPrompt("");
      handleSettingChange("prompt", "");
    }
  }, [selectedPrompt?.prompt]);

  useEffect(() => {
    if (generateExact) {
      handleSettingChange("seed", selectedPrompt?.seed || "");
    } else {
      // If generateExact is false, we can set seed to an empty string
      handleSettingChange("seed", "");
    }
  }, [generateExact, selectedPrompt?.seed]);

  return (
    <div className="space-y-4">
      <div>
        <Typography className="text-gray-300">Transition Prompt</Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={3}
          placeholder="Describe the transition between images..."
          onChange={(e) => {
            setPrompt(e.target.value);
            handleSettingChange("prompt", e.target.value);
          }}
          value={prompt}
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe how you want the transition to occur
        </p>
      </div>

      <div>
        <Typography className="text-gray-300">Aspect Ratio</Typography>
        <select
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          onChange={(e) => handleSettingChange("aspect_ratio", e.target.value)}
          defaultValue="16:9"
        >
          <option value="16:9">16:9 (Widescreen)</option>
          <option value="9:16">9:16 (Portrait)</option>
          <option value="1:1">1:1 (Square)</option>
          <option value="4:3">4:3 (Classic)</option>
        </select>
        <p className="text-xs text-gray-400 mt-1">Output video aspect ratio</p>
      </div>

      <div>
        <Typography className="text-gray-300">Style (Optional)</Typography>
        <select
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          onChange={(e) => handleSettingChange("style", e.target.value)}
          defaultValue=""
        >
          <option value="">Default</option>
          <option value="anime">Anime</option>
          <option value="3d_animation">3D Animation</option>
          <option value="clay">Clay</option>
          <option value="comic">Comic</option>
          <option value="cyberpunk">Cyberpunk</option>
        </select>
        <p className="text-xs text-gray-400 mt-1">
          Visual style for the transition
        </p>
      </div>

      <div>
        <Typography className="text-gray-300">
          Negative Prompt (Optional)
        </Typography>
        <TextareaAutosize
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white resize-none"
          rows={2}
          placeholder="What you don't want in the result..."
          onChange={(e) =>
            handleSettingChange("negative_prompt", e.target.value)
          }
        />
        <p className="text-xs text-gray-400 mt-1">
          Describe what should be avoided in the transition
        </p>
      </div>

      <div>
        <Typography className="text-gray-300">Seed (Optional)</Typography>
        <Input
          type="number"
          className="w-full p-2 bg-gray-700 border border-gray-600 rounded text-white"
          placeholder="Leave empty for random"
          onChange={(e) => {
            setSeed(e.target.value);
            handleSettingChange("seed", e.target.value);
          }}
          inputProps={{ style: { color: "white" } }}
          value={seed}
        />
        <p className="text-xs text-gray-400 mt-1">For reproducible results</p>
      </div>
    </div>
  );
};

export default PixverseTransitionSettings;
